import { createSlotRecipe } from './runtime';

const segmentedConfig = {"name":"segmented","slots":["root","item","icon"]}

export const segmented = /* @__PURE__ */ createSlotRecipe(segmentedConfig)